
export class Perfil {

    usuarioUuid?: string;
    senhaAtual?: string;
    novaSenha?: string;
    confirmacaoNovaSenha?: string;

}